import {Component, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {PictureService} from './picture.service';
import {UIRouter} from '@uirouter/angular';
import {Picture} from './picture.model';
import {TranslateService} from '@ngx-translate/core';
import {FileService} from '../file/file.service';
import {EnumerationService} from '../enumeration/enumeration.service';

@Component({
  selector: 'app-picture-form',
  templateUrl: './picture-form.component.html'
})
export class PictureFormComponent extends FormComponent implements OnInit {
  public picture: Picture = new Picture();
  public pictureTypes: string[];
  public formTitle: string;
  public stateIdParam: string = 'pictureId';

  constructor(
    protected router: UIRouter,
    private pictureService: PictureService,
    private translate: TranslateService,
    private fileService: FileService,
    private enumService: EnumerationService,
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.enumService.get('pictureType').subscribe((pictureTypes) => {
      this.pictureTypes = pictureTypes;
    });

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('picture.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.pictureService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}/channel/${this.router.stateService.params.channelId}`);
        this.translate.get('picture.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.pictureService.get(this.router.stateService.params[this.stateIdParam]).map((picture) => {
          picture.setFileSrc(this.fileService.getLinkById(picture.fileId));
          return picture;
        }).subscribe((picture) => {
          this.picture = picture;
        });
      } break;
    }
  }

  public fileChange(evt) {
    this.picture.setFile(evt.target.files);
  }

  public save(): void {
    const currentStateParts = this.router.stateService.$current.name.split('.');
    currentStateParts.pop();
    currentStateParts.pop();
    const parentState = currentStateParts.join('.');

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.pictureService.add(this.picture).subscribe((result) => {
          this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.pictureService.update(this.picture).subscribe((result) => {
          this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
        });
      } break;
    }

  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture-form.component.ts